<template>
    <div class="home">
        <HelloWorld :back="1"></HelloWorld>
        <div class="home_left">
            <iframe :src="src" frameborder="0"  class="home_img" ></iframe>
            <!-- <img class="home_img" :src="main.first_image" alt=""> -->
            <div class="home_top" v-html="main.first_title"></div>
            <div class="home_com" v-html="main.first_content"></div>
            <a :href="main.first_learn_more" class="home_bom">
                <div class="nav_name">
                    <p>{{ $t('home.name') }}</p>
                    <img src="@/assets/top/icon_goto.png" alt="">
                </div>
            </a>
            <div class="main_box" v-for="item,index in designList" :key="index">
                <div v-if="item.type == 1" style="width: 100%;">
                    <img class="img_nav" src="@/assets/img.png" alt="">
                    <div class="player-container" style="margin-bottom: 14px;">
                        <!-- <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :options="playerOptions"></video-player> -->
                        <video muted="true" loop="true" webkit-playsinline="true" x5-video-type="h5" autoplay width="100%" 
                            :poster="item.video_cover" oncontextmenu="return false" height="auto" type="video/mp4" :src="item.cover"></video>
                        <!-- <img class="nau_sw" v-else :src="item.video_cover" alt=""> -->
                        <div class="home_cem" style="position: absolute;bottom: 60px;left: 0;" :style="item.ui_type==2?'color:#fff':'color:#1D1E1F'">
                            <div class="home_text1">{{ item.goods_first_name }}</div>
                            <div class="home_text_two1">{{item.content}}</div>
                            <div class="home_text_s1" @click.stop="homeClisy">
                                <div class="home_text_left1" :style="item.ui_type==2?'border: 2px solid #fff;color:#fff':'border: 2px solid #1D1E1F;color:#1D1E1F'" @click="homeBoxs(item.goods_first)">{{ $t('home.name') }}</div>
                                <a :href="item.buy_url" target="_blank">
                                    <div class="home_text_left1" :style="item.ui_type==2?'border: 2px solid #fff;color:#fff':'border: 2px solid #1D1E1F;color:#1D1E1F'">{{ $t('home.Buy') }}</div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main" v-if="item.type == 2">
                    <img class="main_img" :src="item.image" alt="">
                    <div class="home_cem home_type" :class="item.ui_type==2?'home_typs1':'home_typs2'" :style="item.ui_type==2?'color:#fff':'color:#1D1E1F'">
                        <div class="home_text">{{ item.goods_first_name }}</div>
                        <div class="main_text3" v-if="item.new_display == 1">{{ $t('home.THE') }}</div>
                        <div class="home_text_two">{{ item.content }}</div>
                        <div class="home_text_s">
                            <div class="home_text_left" @click="homeBoxs(item.goods_first)" :style="item.ui_type==2?'border: 2px solid #fff;color:#fff':'border: 2px solid #1D1E1F;color:#1D1E1F'">{{ $t('home.name') }}</div>
                            <a :href="item.buy_url" target="_blank"><div class="home_text_left" :style="item.ui_type==2?'border: 2px solid #fff;color:#fff':'border: 2px solid #1D1E1F;color:#1D1E1F'">{{ $t('home.Buy') }}</div></a>
                        </div>
                    </div>
                </div>
                <div class="doot_box" v-if="item.type == 3">
                    <div style="width: 50%;">
                        <div class="doot_left" style="margin-right: 10px;">
                            <div class="main">
                                <img class="main_img1" :src="item.image" alt="">
                                <div class="home_cem home_type2" :class="item.ui_type==2?'home_typs1':'home_typs2'" :style="item.ui_type==2?'color:#fff':'color:#1D1E1F'">
                                    <div class="home_text" style="font-size: 40px;line-height: 30px;">{{item.goods_first_name}}</div>
                                    <div class="main_text3" style="font-size: 13px;" v-if="item.new_display == 1">{{ $t('home.THE') }}</div>
                                    <div class="home_text_two2">{{ item.content }}</div>
                                    <div class="home_text_s">
                                        <div class="home_text_left" @click="homeBoxs(item.goods_first)" :style="item.ui_type==2?'border: 2px solid #fff;color:#fff':'border: 2px solid #1D1E1F;color:#1D1E1F'">{{ $t('home.name') }}</div>
                                        <a :href="item.buy_url" target="_blank"><div class="home_text_left" :style="item.ui_type==2?'border: 2px solid #fff;color:#fff':'border: 2px solid #1D1E1F;color:#1D1E1F'">{{ $t('home.Buy') }}</div></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width: 50%;">
                        <div class="doot_left" style="margin-left: 10px;">
                            <div class="main">
                                <img class="main_img1" :src="item.image_second" alt="">
                                <div class="home_cem home_type2" :class="item.ui_type==2?'home_typs1':'home_typs2'" :style="item.ui_type==2?'color:#fff':'color:#1D1E1F'">
                                    <div class="home_text" style="font-size: 40px;line-height: 30px;">{{item.goods_second_name}}</div>
                                    <div class="main_text3" style="font-size: 13px;" v-if="item.new_display_second == 1">{{ $t('home.THE') }}</div>
                                    <div class="home_text_two2">{{ item.content_second }}</div>
                                    <div class="home_text_s">
                                        <div class="home_text_left" @click="homeBoxs(item.goods_second)" :style="item.ui_type==2?'border: 2px solid #fff;color:#fff':'border: 2px solid #1D1E1F;color:#1D1E1F'">{{ $t('home.name') }}</div>
                                        <a :href="item.buy_second_url" target="_blank"><div class="home_text_left" :style="item.ui_type==2?'border: 2px solid #fff;color:#fff':'border: 2px solid #1D1E1F;color:#1D1E1F'">{{ $t('home.Buy') }}</div></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main_mes" v-if="item.type == 4" v-html="item.title"></div>
                <!-- <div class="main" v-if="index==1||index==2||index == 3" :style="index==1?'background: linear-gradient( 180deg, rgba(245,246,247) 0%, rgba(245,246,247) 50% , rgba(0,0,0,0.15) 100%);':'background: linear-gradient( 180deg, rgba(0,0,0,0.15) 0%, rgba(245,246,247) 50% , rgba(245,246,247) 100%)'">
                    <img class="main_img" :src="item.small_image" alt="">
                    <div class="home_cem" style="position: absolute;left: 0;top: 60px;" :style="index==2||index==3?'color:#fff':'color:#1D1E1F'">
                        <div class="home_text">{{ item.name }}</div>
                        <div class="main_text3" v-if="index==3">{{ $t('home.THE') }}</div>
                        <div class="home_text_two">{{ item.content }}</div>
                        <div class="home_text_s">
                            <div class="home_text_left" @click="homeBoxs(item.id)" :style="index==2||index==3?'border: 2px solid #fff;color:#fff':'border: 2px solid #1D1E1F;color:#1D1E1F'">{{ $t('home.name') }}</div>
                            <a :href="item.buy_url"><div class="home_text_left" :style="index==2||index==3?'border: 2px solid #fff;color:#fff':'border: 2px solid #1D1E1F;color:#1D1E1F'">{{ $t('home.Buy') }}</div></a>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="doot_box">
                    <div style="width: 50%;" v-for="item,index in list2" :key="index">
                        <div class="doot_left" :style="index == 0?'margin-right: 10px;':'margin-left: 10px;'">
                            <div class="main" :style="index==0?'background: linear-gradient( 180deg, rgba(245,246,247) 0%, rgba(245,246,247) 50% , rgba(0,0,0,0.15) 100%);':'background: linear-gradient( 180deg, rgba(0,0,0,0.15) 0%, rgba(245,246,247) 50% , rgba(245,246,247) 100%)'">
                                <img class="main_img1" :src="item.small_image" alt="">
                                <div class="home_cem" style="position: absolute;left: 0;top: 48px;" :style="index==0?'color:#1D1E1F':'color:#fff'">
                                    <div class="home_text" style="font-size: 40px;line-height: 30px;">{{item.name}}</div>
                                    <div class="main_text3" style="font-size: 13px;">{{ $t('home.THE') }}</div>
                                    <div class="home_text_two2">{{ item.content }}</div>
                                    <div class="home_text_s">
                                        <div class="home_text_left" @click="homeBoxs(item.id)" :style="index == 0?'border: 2px solid #1D1E1F;color:#1D1E1F':'border: 2px solid #fff;color:#fff'">{{ $t('home.name') }}</div>
                                        <a :href="item.buy_url"><div class="home_text_left"  :style="index == 0?'border: 2px solid #1D1E1F;color:#1D1E1F':'border: 2px solid #fff;color:#fff'">{{ $t('home.Buy') }}</div></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="main_box">
                <div class="main_mes" v-html="main.title2"></div>
                <div class="main" style="background: #F58556;display: flex;align-items: center;justify-content: center;">
                    <img class="main_img3" :src="main.second_image" alt="">
                    <div class="home_cem" style="position: absolute;left: 0;top: 60px;color:#fff">
                        <div class="home_text" style="width: 600px;" v-html="main.second_title"></div>
                        <div class="home_text_two" v-html="main.second_content"></div>
                    </div>
                </div>
            </div>
            <div class="main1">
                <div class="home_cem" style="color:#fff;margin-top: 60px;">
                    <div class="home_text1" v-html="main.third_title"></div>
                    <div class="home_text_two1" style="width: 660px;" v-html="main.third_content"></div>
                    <div class="home_text_s1">
                        <img class="home_image"  @mouseenter="enters4()" @mouseleave="leave()" src="@/assets/top/button.png" alt="">
                        <img class="home_image" @mouseenter="enters5()" @mouseleave="leave()" src="@/assets/top/button2.png" alt="">
                        <div class="home_navs" v-if="shiftIn" style="position: absolute;left: -30px;bottom: -298px;">
                            <img class="navs_img" src="@/assets/list/app.png" alt="">
                            <div class="navs_box">
                                <img class="navs_imgae" :src="main3.image" alt="">
                                <div class="navs_cem">
                                    <img src="@/assets/list/qr2.png" alt="">
                                    <p>{{ main3.name }}</p>
                                </div>
                                <div class="navs_text">{{ main3.content }}</div>
                            </div>
                        </div>
                        <div class="home_navs" v-if="shiftIn2" style="position: absolute;right: -30px;bottom: -298px;">
                            <img class="navs_img" src="@/assets/list/app.png" alt="">
                            <div class="navs_box">
                                <img class="navs_imgae" :src="main2.image" alt="">
                                <div class="navs_cem">
                                    <img src="@/assets/list/qr3.png" alt="">
                                    <p>{{ main2.name }}</p>
                                </div>
                                <div class="navs_text">{{ main2.content }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="home_nons">
                        <img class="home_nons_img" src="@/assets/img_home08_FreeApp-phone_2x.png" alt="">
                        <img class="home_nons_box" :src="main.third_git" alt="">
                    </div>
                </div>
            </div>
            <bomFooter></bomFooter>
        </div>
        <div v-if="showNav" style="width: 100%;height: 100%;position: fixed;left: 0;top: 0;background: #fff;overflow: hidden;z-index: 99999999;">
            <van-overlay :show="showNav" style="background: #fff;">
                <div class="name_box" style="z-index: 99999;">
                    <iframe :src="src1" frameborder="0" class="name_img"></iframe>
                </div>
            </van-overlay>
        </div>
    </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue'
import bomFooter from '@/components/pages/bomFooter.vue'
import { homeInfo, appInfo, designHomeIndex } from '@/api/api'
// import { Loading } from "element-ui";
export default {
    data() {
        return {
            showNav:true,
            playerOptions: {
                // 视频 url
                sources: [
                    {
                        src: '',
                        type: "video/mp4",
                    },
                ],
                //循环播放
                loop: true,
                // 其他设置项
                autoplay: true,
                //是否静音播放
                muted:true,
                //控制进度条是否显示
                controls: false,
                //视频封面
                poster: "",
            },
            list:[],
            main:{},
            list2:[],
            shiftIn:false,
            shiftIn2:false,
            src:'/Loading.html',
            src1:'/Loading2.html',
            main2:{},
            main3:{},
            loadingInstance:null,
            autoplays:'',
            designList:[]
        };
    },
    components: {
        HelloWorld,
        bomFooter
    },
    created() {
        
    },
    mounted() {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        this.getList()
        this.navList()
        console.log(window.screen.width,window.screen.height)
    },
    methods: {
        getList(){
            // this.loadingInstance = Loading.service({
            //     fullscreen: true,
            //     text: "",
            //     background: "rgba(0, 0, 0, .7)",
            // });
            let type = localStorage.getItem('type')
            designHomeIndex({
                type: type
            }).then(res=>{
                console.log(res);
                this.designList = res.data
            })
            homeInfo({
                id:2,
                type:type
            }).then(res=>{
                this.list2=[]
                this.main = res.data
                if(res.data.home_recommend.length > 1){
                    // this.playerOptions.poster = res.data.home_recommend[0].video_cover
                    this.playerOptions.sources[0].src = res.data.home_recommend[0].video
                    this.autoplays = res.data.home_recommend[0].video
                }
                this.list = res.data.home_recommend.slice(0,4)
                if(res.data.home_recommend.length>4){
                    this.list2.push(res.data.home_recommend[4])
                    this.list2.push(res.data.home_recommend[5])
                }
                this.showNav = false
                // this.loadingInstance.close();
            })
            
        },
        navList(){
            let type = localStorage.getItem('type')
            this.main2 = {}
            this.main3 ={}
            appInfo({
                type:type,
                id:6
            }).then(res=>{
                let data = res.data.config
                for(let i=0;i<data.length;i++){
                    if(data[i].storey_type == 2){
                        if(type == 1){
                            if(data[i].id == 19){
                                this.main2 = data[i]
                            }else if(data[i].id == 17){
                                this.main3 = data[i]
                            }
                        }else {
                            if(data[i].id == 34){
                                this.main2 = data[i]
                            }else if(data[i].id == 32){
                                this.main3 = data[i]
                            }
                        }
                    }
                }
            })
        },
        homeBoxs(id){
            this.$router.push({
                path:'/detail',
                query:{
                    id:id
                }
            })
        },
        homeClisy(){
            
        },
        //移入
        enters4(){
            this.shiftIn=true
        },
        //移入
        enters5(){
            this.shiftIn2=true
        },
        //移出
        leave(){
            this.shiftIn=false
            this.shiftIn2=false
        },
    },
};
</script>
<style>
.el-message{
    z-index: 999999999 !important;
}
</style>
<style scoped lang="less">
.name_box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.name_img{
    width: 30px;
    height: 30px;
}
a{
    color:none;
}
* {
    margin: 0;
    padding: 0;
}
.main_text3{
    margin-top: 6px;
    font-family:  font-name;
    font-weight: 500;
    font-size: 15px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    overflow: hidden; //超出文本隐藏
    text-overflow: ellipsis; ///超出部分省略号显示		 
    display: -webkit-box; //弹性盒模型		 
    -webkit-box-orient: vertical; //上下垂直	 
    -webkit-line-clamp: 1; //自定义行数
}
.home{
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.home_left{
    width: 100%;
    margin-top: 70px;
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #FFFFFF;
}
.main_box{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .img_nav{
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 99;
    }
}
.main_mes{
    width: 100%;
    font-family:  font-name;
    font-weight: 700;
    font-size: 54px;
    color: #1D1E1F;
    line-height: 180px;
    text-align: center;
    font-style: normal;
    text-transform: none;
}
.main1{
    width: 100%;
    background: #1D1E1F;
    position: relative;
}
.nau_sw {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    display: block;
    object-fit: cover;
}
.main{
    margin-bottom: 14px;
    width: 100%;
    position: relative;
    background: #f5f6f7;

    .main_img{
        // width: auto;
        width: 100%;
        height: 670px;
        max-width: 100%;
        max-height: 100%;
        display: block;
        object-fit: cover;
    }
    .main_img1{
        width: 100%;
        height: 560px;
        max-width: 100%;
        max-height: 100%;
        display: block;
        object-fit: cover;
    }
    .main_img3{
        width: auto;
        height: 670px;
        max-width: 100%;
        max-height: 100%;
        display: block;
        object-fit: cover;
    }
}
.home_img{
    width: 410px;
    height: 410px;
    margin: 70px 0 40px 0;
}
.home_top{
    width: 600px;
    font-family: font-name;
    font-weight: bold;
    font-size: 54px;
    color: #1D1E1F;
    line-height: 66px;
    text-align: center;
    font-style: normal;
    text-transform: none;
}
.home_com{
    font-family:  font-name;
    font-weight: 400;
    font-size: 24px;
    color: #1D1E1F;
    line-height: 64px;
    text-align: center;
    font-style: normal;
    text-transform: none;
}
.home_bom{
    width: 100%;
    cursor: pointer;
    margin-bottom: 60px;
    .nav_name{
        display: flex;
        align-items: center;
        justify-content: center;

        p{
            font-family:  font-name;
            font-weight: 500;
            font-size: 20px;
            color: #FF4D00;
            text-align: center;
            font-style: normal;
            text-transform: none;
        }
        img{
            width:10px;
            margin: 2px 0 0 10px;
        }
    }
   
}
.player-container {
    width: 100%;
    height: 10.8rem;
    // background: linear-gradient( 180deg, rgba(245,246,247) 0%, rgba(245,246,247) 50% , rgba(0,0,0,0.15) 100%);
    // background: #F5F6F7;
    position: relative;
}
/deep/.vjs-modal-dialog{
    background: linear-gradient( 180deg, rgba(245,246,247) 0%, rgba(245,246,247) 50% , rgba(0,0,0,0.15) 100%);
}
/deep/.video-js {
    width: 100%;
    height: 10.8rem;
    background: #fff;
    border: none;
}

.home_cem{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    .home_text{
        font-family:  font-name;
        font-weight: bold;
        font-size: 54px;
        line-height: 54px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin: 20px 0 0 0;
    }
    .home_text_two{
        width: 42%;
        font-family: font-name;
        font-weight: 400;
        font-size: 24px;
        line-height: 36px;
        text-align: center;
        font-style: normal;
        text-transform: none;
    }
    .home_text_two2{
        width: 50%;
        font-family:  font-name;
        font-weight: 400;
        font-size: 20px;
        line-height: 36px;
        text-align: center;
        font-style: normal;
        text-transform: none;
    }
    .home_text_s{
        display: flex;
        align-items: center;
        justify-content: center;

        .home_text_left{
            margin: 12px 4px 30px 4px;
            padding: 8px 26px;
            border-radius: 20px;
            font-family:  font-name;
            font-weight: 500;
            font-size: 18px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            cursor: pointer;
        }
    }
    .home_text1{
        width: 80%;
        font-family:  font-name;
        font-weight: bold;
        font-size: 54px;
        line-height: 64px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin: 20px 0 0 0;
    }
    .home_text_two1{
        width: 86%;
        font-family:  font-name;
        font-weight: 400;
        font-size: 24px;
        line-height: 36px;
        text-align: center;
        font-style: normal;
        text-transform: none;
    }
    .home_text_s1{
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 99;

        .home_image{
            width: 200px;
            margin: 16px;
            cursor: pointer;
        }
        .home_text_left1{
            margin: 12px 4px 30px 4px;
            padding: 8px 26px;
            border-radius: 20px;
            font-family:  font-name;
            font-weight: 500;
            color: #fff;
            font-size: 18px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            cursor: pointer;
        }
        .home_navs{
            width: 280px;
            height: 310px;
            display: flex;
            flex-direction: column;
            align-items: center;
            z-index: 999;

            .navs_img{
                width: 28px;
                height: 28px;
            }
            .navs_box{
                width: 280px;
                height: 280px;
                border-radius: 16px;
                display: flex;
                align-items: center;
                box-shadow: 0 2px 2px 1px rgba(0,0,0,0.12);
                flex-direction: column;
                background: #fff;

                .navs_imgae{
                    width: 172px;
                    height: 172px;
                    margin: 24px 0 8px 0;
                }
                .navs_cem{
                    display: flex;
                    align-items: center;
                    img{
                        width: 14px;
                        height: 16px;
                        margin-right: 6px;
                    }
                    p{
                        font-family:  font-name;
                        font-weight: bold;
                        font-size: 15px;
                        color: #1D1E1F;
                        text-align: center;
                        font-style: normal;
                        text-transform: none;
                    }
                }
                .navs_text{
                    width: 220px;
                    font-family:  font-name;
                    font-weight: 400;
                    font-size: 11px;
                    color: #1D1E1F;
                    line-height: 14px;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;
                    margin-top: 8px;
                }
            }
            
        }
    }
    .home_nons{
        width: 1000px;
        position: relative;
        margin-bottom: 30px;
    }
    .home_nons_img{
        width: 1000px;
        height: 470px;
        position: absolute;
        left: 0;
        top: 0;
    }
    .home_nons_box{
        width: 1000px;
        height: 470px;
    }
}
.home_type{
    width: 100%;
    height: 260px;
    padding-top: 60px;
    position: absolute;
    left: 0;
    top: 0;
}
.home_type2{
    width: 100%;
    height: 272px;
    padding-top: 48px;
    position: absolute;
    left: 0;
    top: 0;
}
.home_typs1{
    background: linear-gradient( 180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0) 100%);
}
.home_typs2{
    background: linear-gradient( 180deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0) 100%);
}
.doot_box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .doot_left{
        width: 100%;
    }
}
</style>